/* eslint-disable */
import { endpoints } from '../../Constants';
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const cookingRecipesServices = {
	gateway,
	exportCookingRecipes,
	exportCookingRecipesSfg,
	uploadRecipesCSV,
	fetchIngredientDirect,
	recipeStatusUpdate,
	fetchRecipesByStore,
};

function fetchRecipesByStore({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			filters: {
				storeId: req?.data?.storeId,
			},
		}),
	};
	return fetch(endpoints.VIEW_RECIPE_INGREDIENTS, requestOptions).then(handleResponse);
}

function listIngredients({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.INGREDIENT_DIRECT, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function gateway({ req, method }) {
	switch (method) {
		case 'CREATE':
			return createRecipe({
				req,
			});
		case 'VIEW':
			return viewRecipe({
				req,
			});
		case 'LIST':
			return listRecipes({
				req,
			});
		case 'UPDATE':
			return updateRecipe({
				req,
			});
		case 'PATCH':
			return patchRecipe({
				req,
			});
		case 'DELETE':
			return deleteRecipe({
				req,
			});
		case 'LIST_INGREDIENTS':
			return listIngredients({
				req,
			});
		default:
			break;
	}
	return new Promise();
}

function createRecipe({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.SAVE_RECIPE, requestOptions).then(handleResponse);
}
function patchRecipe({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.UPDATE_RECIPE_FLAGS, params);

	const requestOptions = {
		method: 'PATCH',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function updateRecipe({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.SAVE_RECIPE, params);

	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function viewRecipe({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.VIEW_RECIPE, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function listRecipes({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.LIST_RECIPES, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}
function deleteRecipe({ req }) {
	const params = {
		...req.params,
	};
	const url = toQueryStringURL(endpoints.CUSTOMIZATIONS, params);
	const requestOptions = {
		method: 'DELETE',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function exportCookingRecipes({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.EXPORT_RECIPES, requestOptions);
}

function exportCookingRecipesSfg({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.EXPORT_RECIPES_SFG, requestOptions);
}

function uploadRecipesCSV({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.UPLOAD_RECIPES_CSV, requestOptions).then(handleResponse);
}
function recipeStatusUpdate(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.RECIPE_STATUS_CHANGE, requestOptions).then(handleResponse);
}

function fetchIngredientDirect({ req }) {
	return listIngredients({ req });
}

export default cookingRecipesServices;
